export default __webpack_public_path__ + "media/images/images/banner/banner-35-5c5c77943b8e7c62401337dfe75c185b.jpg";